export default __webpack_public_path__ + "static/assets/200001e92bcf3dccc5bcdf6e17b295be.png";